<template>
  <div class="button-line" v-if="buttons()?.length > 0">
    <span v-for="item in buttons()" :key="item.value" class="button">
      {{ item.eventName }}
    </span>
  </div>
</template>
<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  msg: {
    type: Object,
    default: () => {},
    required: true
  }
})
const buttons = () => {
  // 和患者返回的一样，直接使用返回给患者的按钮数据
  if (!props?.msg?.toPatientEvents) return []
  const toArr = JSON.parse(props.msg.toPatientEvents)
  if (toArr.length === 0) return []
  // 过滤掉不需要的按钮
  const buttons = toArr
  return buttons
}
</script>
<style scoped lang="scss">
.button-line {
  margin: 5px 0;
  .button {
    padding: 6px 0;
    color: #4c6ee0;
    font-weight: 500;
    margin-right: 24px;
    &:last-child {
      margin: 0;
    }
  }
}
</style>
